(function () {
  'use strict';

  var slug = function (value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  var collectionHandle = function (url) {
    return String(url || '').split('?')[0].split('/').filter(Boolean).pop() || '';
  };

  var fitmentYear = function (value) {
    var year = Number(value);
    return Number.isFinite(year) && year >= 1900 && year <= 2200 ? year : null;
  };

  var unique = function (items) {
    return Array.from(new Set(items));
  };

  var Fitment = function (root) {
    this.root = root;
    this.form = root.querySelector('[data-hmz-fitment-form]');
    this.make = root.querySelector('[data-hmz-fitment-make]');
    this.model = root.querySelector('[data-hmz-fitment-model]');
    this.year = root.querySelector('[data-hmz-fitment-year]');
    this.statusNode = root.querySelector('[data-hmz-fitment-status]');
    this.fullGuideLink = root.querySelector('[data-hmz-fitment-full-link]');
    this.results = root.querySelector('[data-hmz-fitment-results]');
    this.resultsTitle = root.querySelector('[data-hmz-fitment-results-title]');
    this.resultsCount = root.querySelector('[data-hmz-fitment-results-count]');
    this.resultsGrid = root.querySelector('[data-hmz-fitment-results-grid]');
    this.resultsEmpty = root.querySelector('[data-hmz-fitment-results-empty]');
    this.resetButton = root.querySelector('[data-hmz-fitment-reset]');
    this.viewAllLink = root.querySelector('[data-hmz-fitment-view-all]');
    this.homeMode = root.dataset.homeMode === 'true';
    this.displayLimit = Math.max(0, Number(root.dataset.displayLimit || 0) || 0);
    this.records = [];
    this.options = [];
    this.groups = new Map();
    this.selectedModel = null;
    this.cardCache = new Map();
    this.pageFetches = new Map();
    this.requestId = 0;
    this.currentPage = Number(new URL(window.location.href).searchParams.get('page') || 1) || 1;
  };

  Fitment.prototype.init = function () {
    if (this.root.dataset.hmzFitmentInitialized === 'true') return;
    this.root.dataset.hmzFitmentInitialized = 'true';

    this.records = this.readRecords(this.root);
    if (this.records.length) {
      this.setup();
      return;
    }

    this.setStatus('Loading fitment data…');
    this.loadBaseRecords()
      .then(function (records) {
        this.records = records;
        this.setup();
      }.bind(this))
      .catch(function () {
        this.setStatus('Fitment data could not be loaded. Open the full Fitment Guide to continue.');
      }.bind(this));
  };

  Fitment.prototype.parseRecords = function (node) {
    if (!node) return [];
    try {
      return (JSON.parse(node.textContent || '{}').records || [])
        .map(function (record) {
          var start = fitmentYear(record.startYear);
          var end = fitmentYear(record.endYear) || start;
          if (!start || !end) return null;
          return {
            make: String(record.make || ''),
            makeKey: slug(record.makeKey || record.make),
            model: String(record.model || ''),
            modelKey: slug(record.modelKey || record.model),
            startYear: Math.min(start, end),
            endYear: Math.max(start, end),
            productHandle: String(record.productHandle || ''),
            collectionHandles: Array.isArray(record.collectionHandles) ? record.collectionHandles.map(String) : []
          };
        })
        .filter(Boolean);
    } catch (error) {
      return [];
    }
  };

  Fitment.prototype.readRecords = function (scope) {
    return this.parseRecords((scope || document).querySelector('[data-hmz-fitment-data]'));
  };

  Fitment.prototype.vehicleCatalog = function () {
    var node = document.querySelector('#vehicle-compatibility-catalog');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent || '{}');
      return Array.isArray(parsed.vehicles) ? parsed.vehicles : [];
    } catch (error) {
      return [];
    }
  };

  Fitment.prototype.matchesVehicle = function (record, vehicle) {
    if (record.makeKey !== slug(vehicle.make)) return false;
    var handle = collectionHandle(vehicle.collectionUrl);
    if (handle && record.collectionHandles.indexOf(handle) !== -1) return true;
    var model = slug(vehicle.model);
    if (record.modelKey === model) return true;
    if (model === 'cbr1000rr' && /^cbr1000rr-(sc59|sc77|fireblade)/.test(record.modelKey)) return true;
    if (model === 'ninja-zx-6r' && /(^|-)zx-6r(-|$)/.test(record.modelKey)) return true;
    return false;
  };

  Fitment.prototype.buildOptions = function (records, catalog) {
    var options = [];
    var seen = new Set();

    catalog.forEach(function (vehicle) {
      var matching = records.filter(function (record) {
        return this.matchesVehicle(record, vehicle);
      }, this);
      if (!matching.length) return;

      matching.forEach(function (record) {
        seen.add(record.productHandle + '|' + record.modelKey);
      });

      options.push({
        make: String(vehicle.make || ''),
        makeKey: slug(vehicle.make),
        model: String(vehicle.model || ''),
        modelKey: slug(vehicle.model),
        collectionHandle: collectionHandle(vehicle.collectionUrl),
        years: unique(matching.reduce(function (years, record) {
          for (var year = record.startYear; year <= record.endYear; year += 1) years.push(year);
          return years;
        }, [])).sort(function (a, b) { return a - b; })
      });
    }, this);

    records.forEach(function (record) {
      if (seen.has(record.productHandle + '|' + record.modelKey)) return;
      var existing = options.find(function (item) {
        return item.makeKey === record.makeKey && item.modelKey === record.modelKey;
      });
      if (!existing) {
        existing = {
          make: record.make,
          makeKey: record.makeKey,
          model: record.model,
          modelKey: record.modelKey,
          collectionHandle: '',
          years: []
        };
        options.push(existing);
      }
      for (var year = record.startYear; year <= record.endYear; year += 1) {
        if (existing.years.indexOf(year) === -1) existing.years.push(year);
      }
      existing.years.sort(function (a, b) { return a - b; });
    });

    return options;
  };

  Fitment.prototype.groupOptions = function (options) {
    var groups = new Map();
    options.forEach(function (model) {
      if (!groups.has(model.makeKey)) groups.set(model.makeKey, []);
      groups.get(model.makeKey).push(model);
    });
    return groups;
  };

  Fitment.prototype.addOption = function (select, value, label) {
    select.appendChild(new Option(label, value));
  };

  Fitment.prototype.resetSelect = function (select, placeholder, disabled) {
    select.innerHTML = '';
    var option = new Option(placeholder, '');
    option.disabled = true;
    option.selected = true;
    select.appendChild(option);
    select.value = '';
    select.disabled = disabled;
    select.setAttribute('aria-disabled', String(disabled));
  };

  Fitment.prototype.populateMakes = function () {
    var placeholder = this.make.options[0] ? this.make.options[0].textContent : 'Select make';
    this.resetSelect(this.make, placeholder, false);
    var added = new Set();
    this.options.forEach(function (model) {
      if (added.has(model.makeKey)) return;
      added.add(model.makeKey);
      this.addOption(this.make, model.makeKey, model.make);
    }, this);
  };

  Fitment.prototype.populateModels = function (makeKey) {
    var placeholder = this.model.options[0] ? this.model.options[0].textContent : 'Select model';
    this.resetSelect(this.model, placeholder, !makeKey);
    if (!makeKey) return;
    (this.groups.get(makeKey) || []).forEach(function (model) {
      this.addOption(this.model, model.modelKey, model.model);
    }, this);
    this.model.disabled = false;
    this.model.setAttribute('aria-disabled', 'false');
  };

  Fitment.prototype.populateYears = function (model) {
    var placeholder = this.year.options[0] ? this.year.options[0].textContent : 'Select year';
    this.resetSelect(this.year, placeholder, !model || !model.years.length);
    if (!model || !model.years.length) return;
    model.years.forEach(function (year) {
      this.addOption(this.year, String(year), String(year));
    }, this);
    this.year.disabled = false;
    this.year.setAttribute('aria-disabled', 'false');
  };

  Fitment.prototype.setup = function () {
    this.options = this.buildOptions(this.records, this.vehicleCatalog());
    this.groups = this.groupOptions(this.options);
    this.populateMakes();
    this.bind();
    this.setStatus(this.homeMode ? 'Select your motorcycle to view compatible products.' : 'Select your motorcycle to narrow the catalog.');
    this.restoreFromQuery();
  };

  Fitment.prototype.setStatus = function (text) {
    if (this.statusNode) this.statusNode.textContent = text || '';
  };

  Fitment.prototype.setBrowseVisible = function (visible) {
    if (this.homeMode) return;
    var heading = document.querySelector('[data-hmz-all-products-heading]');
    var collection = document.querySelector('.section-collection-products');
    if (heading) heading.hidden = !visible;
    if (collection) collection.hidden = !visible;
  };

  Fitment.prototype.setGuideLink = function (valid) {
    if (!this.fullGuideLink) return;
    var url = new URL('/pages/fitment-guide', window.location.origin);
    if (valid && this.selectedModel && this.year.value) {
      url.searchParams.set('make', this.make.value);
      url.searchParams.set('model', this.selectedModel.modelKey);
      url.searchParams.set('year', this.year.value);
    }
    this.fullGuideLink.href = url.pathname + url.search;
  };

  Fitment.prototype.clearResults = function (resetControls) {
    this.requestId += 1;
    if (this.results) {
      this.results.hidden = true;
      this.results.setAttribute('aria-busy', 'false');
    }
    if (this.resultsGrid) this.resultsGrid.innerHTML = '';
    if (this.resultsEmpty) this.resultsEmpty.hidden = true;
    if (this.viewAllLink) this.viewAllLink.hidden = true;
    this.setBrowseVisible(true);
    this.setGuideLink(false);

    if (resetControls) {
      this.selectedModel = null;
      this.populateMakes();
      this.resetSelect(this.model, 'Select model', true);
      this.resetSelect(this.year, 'Select year', true);
      this.setStatus(this.homeMode ? 'Select your motorcycle to view compatible products.' : 'Select your motorcycle to narrow the catalog.');
    }
  };

  Fitment.prototype.compatibleHandles = function () {
    var year = fitmentYear(this.year.value);
    if (!year || !this.selectedModel) return [];

    var vehicle = {
      make: this.selectedModel.make,
      model: this.selectedModel.model,
      collectionUrl: this.selectedModel.collectionHandle ? '/collections/' + this.selectedModel.collectionHandle : ''
    };

    return unique(this.records.filter(function (record) {
      return year >= record.startYear && year <= record.endYear && this.matchesVehicle(record, vehicle);
    }, this).map(function (record) {
      return record.productHandle;
    }).filter(Boolean));
  };

  Fitment.prototype.cardHandle = function (card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  Fitment.prototype.cacheCards = function (scope) {
    var collection = scope.querySelector('.section-collection-products');
    if (!collection) return 0;
    var count = 0;
    collection.querySelectorAll('xo-product').forEach(function (card) {
      var handle = this.cardHandle(card);
      if (!handle || this.cardCache.has(handle)) return;
      this.cardCache.set(handle, card.outerHTML);
      count += 1;
    }, this);
    return count;
  };

  Fitment.prototype.collectionPageUrl = function (page) {
    var current = new URL(window.location.href);
    var url = new URL(this.root.dataset.collectionUrl || '/collections/all-products-1', window.location.origin);
    ['preview_theme_id', 'view', 'country', 'currency'].forEach(function (key) {
      var value = current.searchParams.get(key);
      if (value) url.searchParams.set(key, value);
    });
    if (!url.searchParams.get('view') && current.searchParams.get('preview_theme_id')) {
      url.searchParams.set('view', 'all-products');
    }
    if (page > 1) url.searchParams.set('page', String(page));
    return url.toString();
  };

  Fitment.prototype.filteredCollectionUrl = function () {
    var current = new URL(window.location.href);
    var url = new URL(this.root.dataset.collectionUrl || '/collections/all-products-1', window.location.origin);
    if (this.selectedModel && this.year.value) {
      url.searchParams.set('make', this.make.value);
      url.searchParams.set('model', this.selectedModel.modelKey);
      url.searchParams.set('year', this.year.value);
    }
    var previewThemeId = current.searchParams.get('preview_theme_id');
    if (previewThemeId) {
      url.searchParams.set('preview_theme_id', previewThemeId);
      url.searchParams.set('view', 'all-products');
    }
    ['country', 'currency'].forEach(function (key) {
      var value = current.searchParams.get(key);
      if (value) url.searchParams.set(key, value);
    });
    return url.pathname + url.search;
  };

  Fitment.prototype.restoreFromQuery = function () {
    var params = new URL(window.location.href).searchParams;
    var makeKey = slug(params.get('make'));
    var modelKey = slug(params.get('model'));
    var year = fitmentYear(params.get('year'));
    if (!makeKey || !modelKey || !year || !this.groups.has(makeKey)) return;

    this.make.value = makeKey;
    this.populateModels(makeKey);
    this.model.value = modelKey;
    this.selectedModel = (this.groups.get(makeKey) || []).find(function (model) {
      return model.modelKey === modelKey;
    }) || null;
    if (!this.selectedModel) return;

    this.populateYears(this.selectedModel);
    if (this.selectedModel.years.indexOf(year) === -1) return;
    this.year.value = String(year);
    this.showCompatibleProducts();
  };

  Fitment.prototype.loadBaseRecords = function () {
    return fetch(this.collectionPageUrl(1), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Fitment data request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return this.readRecords(doc);
      }.bind(this));
  };

  Fitment.prototype.fetchCollectionPage = function (page) {
    if (this.pageFetches.has(page)) return this.pageFetches.get(page);
    var request = fetch(this.collectionPageUrl(page), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Product page request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        this.cacheCards(doc);
        return doc;
      }.bind(this));
    this.pageFetches.set(page, request);
    return request;
  };

  Fitment.prototype.loadCards = function (handles) {
    this.cacheCards(document);
    var totalProducts = Number(this.root.dataset.productCount || 0);
    var perPage = Number(this.root.dataset.productsPerPage || 16) || 16;
    var maxPages = totalProducts > 0 ? Math.ceil(totalProducts / perPage) : 10;

    var missing = function () {
      return handles.filter(function (handle) { return !this.cardCache.has(handle); }, this);
    }.bind(this);

    var chain = Promise.resolve();
    for (var page = 1; page <= maxPages; page += 1) {
      if (page === this.currentPage && !this.homeMode) continue;
      (function (pageNumber) {
        chain = chain.then(function () {
          if (!missing().length) return null;
          return this.fetchCollectionPage(pageNumber).catch(function () { return null; });
        }.bind(this));
      }.call(this, page));
    }

    return chain.then(function () {
      return handles.map(function (handle) {
        return this.cardCache.get(handle) || '';
      }, this).filter(Boolean);
    }.bind(this));
  };

  Fitment.prototype.renderCards = function (cards) {
    this.resultsGrid.innerHTML = '';
    cards.forEach(function (html) {
      var template = document.createElement('template');
      template.innerHTML = html.trim();
      var card = template.content.firstElementChild;
      if (card) this.resultsGrid.appendChild(card);
    }, this);
  };

  Fitment.prototype.showCompatibleProducts = function () {
    var year = fitmentYear(this.year.value);
    if (!year || !this.selectedModel) return;

    var handles = this.compatibleHandles();
    var displayHandles = this.displayLimit > 0 ? handles.slice(0, this.displayLimit) : handles;
    var requestId = ++this.requestId;
    var vehicleLabel = this.selectedModel.make + ' ' + this.selectedModel.model + ' · ' + year;

    this.setGuideLink(true);
    this.setBrowseVisible(false);
    this.results.hidden = false;
    this.results.setAttribute('aria-busy', 'true');
    this.resultsTitle.textContent = vehicleLabel;
    this.resultsCount.textContent = 'Loading compatible products…';
    this.resultsGrid.innerHTML = '';
    this.resultsEmpty.hidden = true;
    if (this.viewAllLink) this.viewAllLink.hidden = true;
    this.setStatus('Loading compatible products…');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: this.homeMode ? 'homepage_fitment_inline_results' : 'collection_fitment_inline_results',
      make: this.make.value,
      model: this.selectedModel.modelKey,
      year: year,
      compatible_product_count: handles.length
    });

    if (!handles.length) {
      this.results.setAttribute('aria-busy', 'false');
      this.resultsCount.textContent = '0 compatible products';
      this.resultsEmpty.hidden = false;
      this.setStatus('No compatible products found for this selection.');
      return;
    }

    if (this.homeMode && this.viewAllLink && this.displayLimit > 0 && handles.length > this.displayLimit) {
      this.viewAllLink.textContent = 'View all ' + handles.length + ' compatible products →';
      this.viewAllLink.href = this.filteredCollectionUrl();
      this.viewAllLink.hidden = false;
    }

    this.loadCards(displayHandles)
      .then(function (cards) {
        if (requestId !== this.requestId) return;
        this.renderCards(cards);
        this.results.setAttribute('aria-busy', 'false');
        this.resultsCount.textContent = handles.length + ' compatible product' + (handles.length === 1 ? '' : 's');
        this.resultsEmpty.hidden = cards.length > 0;

        if (!cards.length) {
          this.setStatus('Compatible products could not be loaded. Open the full Fitment Guide to continue.');
        } else if (this.homeMode && handles.length > cards.length) {
          this.setStatus('Showing ' + cards.length + ' of ' + handles.length + ' compatible products.');
        } else if (cards.length === handles.length) {
          this.setStatus(handles.length + ' compatible product' + (handles.length === 1 ? '' : 's') + ' shown below.');
        } else {
          this.setStatus('Some compatible products could not be loaded. Open the full Fitment Guide for the complete list.');
        }
      }.bind(this))
      .catch(function () {
        if (requestId !== this.requestId) return;
        this.results.setAttribute('aria-busy', 'false');
        this.resultsCount.textContent = 'Unable to load products';
        this.resultsEmpty.hidden = false;
        this.setStatus('Compatible products could not be loaded. Open the full Fitment Guide to continue.');
      }.bind(this));
  };

  Fitment.prototype.bind = function () {
    this.make.addEventListener('change', function () {
      this.clearResults(false);
      this.selectedModel = null;
      this.populateModels(this.make.value);
      this.resetSelect(this.year, 'Select year', true);
      this.setStatus('Choose your model and year.');
    }.bind(this));

    this.model.addEventListener('change', function () {
      this.clearResults(false);
      this.selectedModel = (this.groups.get(this.make.value) || []).find(function (model) {
        return model.modelKey === this.model.value;
      }, this) || null;
      this.populateYears(this.selectedModel);
      this.setStatus(this.selectedModel ? 'Choose your model year.' : '');
    }.bind(this));

    this.year.addEventListener('change', function () {
      var year = fitmentYear(this.year.value);
      var valid = Boolean(year && this.selectedModel && this.selectedModel.years.indexOf(year) !== -1);
      if (valid) this.showCompatibleProducts();
      else this.clearResults(false);
    }.bind(this));

    this.form.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    if (this.resetButton) {
      this.resetButton.addEventListener('click', function () {
        this.clearResults(true);
      }.bind(this));
    }
  };

  var init = function (scope) {
    (scope || document).querySelectorAll('[data-hmz-collection-fitment]').forEach(function (root) {
      new Fitment(root).init();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
